import { FilterOperatorType } from '../components/odata-filter/models/filter-operator-type';
import {
  FilterGroup,
  ODataFilter,
  ODataFilterValues,
  ODataSubFilter,
} from '../components/odata-filter/models/odata-filter';
import { FilterOperator } from '../components/odata-filter/models/operators';
import { SearchValueType } from '../components/odata-filter/models/search-value-type';
import { ODataFilterBuilder } from './odata-filter-builder';

export class ComplexFieldsFilterModel implements ODataFilter {
  childFieldName = '';
  values = [];
  valueType = SearchValueType.EmptyOperator;
  filterGroup = FilterGroup.PersonComplexFields;
  subFilter = new ODataSubFilter();
  constructor(
    public displayName: string,
    public targetField: string,
    public targetFieldId: string,
    public secondFilter?: any
  ) {}
  buildFilter(searchValue: any, filterOperator: FilterOperator, subQueryFilters?: any[]) {
    if (
      filterOperator.displayOperator != FilterOperatorType.isEmpty &&
      filterOperator.displayOperator != FilterOperatorType.isNotEmpty
    ) {
      throw new Error('Invalid Operation');
    }
    let notFilters = subQueryFilters?.filter((x) => x.not).map((x) => x.not);
    let noneNotFilters = subQueryFilters?.filter((x) => !x.not);

    if (filterOperator.displayOperator == FilterOperatorType.isEmpty) {
      return {
        not: {
          [this.targetField]: {
            any: [
              {
                and: [
                  ODataFilterBuilder.buildGuidFilter('id', this.targetFieldId),
                  this.secondFilter ?? {},
                ],
              },
            ],
          },
        },
      };
    } else {
      return {
        [this.targetField]: {
          any: [
            ODataFilterBuilder.buildGuidFilter('id', this.targetFieldId),
            notFilters?.length != 0 ? { not: notFilters } : null,
            noneNotFilters?.length != 0 ? { and: noneNotFilters } : null,
            this.secondFilter ?? {},
          ],
        },
      };
    }
  }
}
